// DataTables initialization
// jQuery and DataTable are already loaded globally in application.js
import 'datatables.net-buttons-bs5'
import pdfMake from 'pdfmake'
import jQuery from 'jquery'

// Configure PDF maker for export buttons
if (window.DataTable && window.DataTable.Buttons) {
  window.DataTable.Buttons.pdfMake(pdfMake);
}

// Ensure jQuery is available
const $ = jQuery;

// Shared accessibility-focused language options
const a11yLanguage = {
  search: "Search:",
  searchPlaceholder: "Filter records...",
  info: "Showing _START_ to _END_ of _TOTAL_ entries",
  infoEmpty: "No entries to show",
  infoFiltered: "(filtered from _MAX_ total entries)",
  paginate: {
    first: "First page",
    previous: "Previous page",
    next: "Next page",
    last: "Last page"
  },
  emptyTable: "No data available in table"
}

$(document).on('turbo:load', function(e) {

  // Add sr-only captions to tables that lack them
  $('table.dataTable').each(function() {
    if (!$(this).find('caption').length) {
      $(this).prepend('<caption class="sr-only">Data table</caption>')
    }
  })

  let my_table = $('#my_table').DataTable({
    destroy: true,
    responsive: true,
    paging: true,
    dom: 'fBrtip',
    orderable: true,
    language: a11yLanguage,
    buttons: [
      { extend: 'copy',
        text: 'Copy to Clipboard | '
      },
      { extend: 'csv',
        text: 'Download Spreadsheet (csv)'
      }
    ]
  });

   let analyticsTable = $('#analytics-table').DataTable({
    destroy: true,
    responsive: true,
    columns: [
        {data: "visit_token"},
        {data: "visitor_token"},
        {data: "user_id"},
        {data: "ip"},
        {data: "user_agent"},
        {data: "referrer"},
        {data: "referring_domain"},
        {data: "landing_page"},
        {data: "browser"},
        {data: "os"},
        {data: "device_type"},
        {data: "country"},
        {data: "region"},
        {data: "city"},
        {data: "latitude"},
        {data: "longitude"},
        {data: "utm_source"},
        {data: "utm_medium"},
        {data: "utm_term"},
        {data: "utm_content"},
        {data: "utm_campaign"},
        {data: "app_version"},
        {data: "os_version"},
        {data: "platform"},
        {data: "started_at"}
    ],
    ajax: { "url": '/admin/analytics/table_data.json',
            "dataSrc": function ( json ) {
              return JSON.parse(json.data);
            }
          },
    paging: true,
    orderable: true,
    language: a11yLanguage,
    buttons: [
      { extend: 'copy',
        text: 'Copy to Clipboard | '
      },
      { extend: 'csv',
        text: 'Download Spreadsheet (csv)'
      }
    ]
  });

  let clientRosterTable = $('#client_roster_table').DataTable({
    destroy: true,
    responsive: true,
    paging: true,
    dom: 'fBrtip',
    orderable: true,
    order: [[5, 'desc']],
    columnDefs: [
      { orderable: false, targets: -1 }
    ],
    language: a11yLanguage,
    buttons: [
      { extend: 'copy',
        text: 'Copy to Clipboard | '
      },
      { extend: 'csv',
        text: 'Download Spreadsheet (csv)'
      }
    ]
  });

  my_table.buttons().container().appendTo( '#my_table_wrapper .col-md-6:eq(0)' );
  analyticsTable.buttons().container().appendTo( '#analytics-table_wrapper .col-md-6:eq(0)' );
  clientRosterTable.buttons().container().appendTo( '#client_roster_table_wrapper .col-md-6:eq(0)' );

  // Add aria-label to DataTables search inputs
  $('.dataTables_filter input').attr('aria-label', 'Search table')

  // Add aria-live to DataTables info regions for screen reader updates
  $('.dataTables_info').attr('aria-live', 'polite')
});
